<template>
    <div class="small-basket-item">
        <a :href="result.detailPage" class="small-basket-item__photo">
            <img :src="result.picture.src" :alt="result.picture.alt">
        </a>
        <div class="small-basket-item__description">
            <a :href="result.detailPage" class="small-basket-item__title">
                {{ result.name }}
            </a>
            <div v-if="result.propsForCheck && result.propsForCheck.SIZES" class="small-basket-item__size">
                {{ getSize(result.propsForCheck.SIZES) }}
            </div>
            <div class="small-basket-item__price">
                <span
                    class="def-price"
                    v-if="result.price && result.price.printPrice"
                >
                    {{ result.price.printPrice }}
                </span>
                <span
                    v-if="result.price && result.price.printPriceOld && +result.price.price !== +result.price.priceOld"
                    class="def-price-old"
                >
                    {{ result.price.printPriceOld }}
                </span>
            </div>
            <div class="small-basket-item__counter">
                <DefCounter :result="result" />
            </div>
        </div>
        <div class="small-basket-item__close">
            <svg @click="removeFromBasket({ id, basketId: result.basket_id })">
                <use xlink:href="#svg-close"></use>
            </svg>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    name: 'SmallBasketItem',
    props: ['result'],
    computed: {
      id() {
          return this.result?.offer?.id || this.result?.id;
      }
    },
    methods: {
        ...mapActions({
            removeFromBasket: 'basket/remove',
        }),
        getSize(SIZES) {
            return SIZES.find(el => el.active)?.displayValue;
        },
    }
}
</script>

<style lang="scss" scoped>
.small-basket-item {
    display: flex;
    padding: 8px;
    background-color: #ffffff;
    @include point-md{
        padding: 8px 17px;
    }
    &:not(:last-child) {
        margin-bottom: 4px;
    }

    &__photo {
        display: block;
        max-width: 76px;
        margin-right: 8px;
        width: 100%;
        @include point-md{
            margin-right: 16px;
        }
        img {
            max-width: 100%;
        }
    }

    &__description {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }

    &__title {
        font-weight: 500;
        font-style: normal;
        font-size: rem(12);
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: #191918;
        margin-bottom: 4px;
        @include point-md {
            font-size: rem(14);
        }
        @include point-lg {
            font-size: rem(16);
        }
    }

    &__size {
        font-size: rem(14);
        line-height: 100%;
        color: #757575;
        margin-bottom: 8px;
    }

    &__close {
        display: flex;
        align-items: center;
        padding-left: 10px;

        &:hover {
            cursor: pointer;
        }
        svg{
            width: 13px;
            height: 13px;
        }
    }

    &__price {
        margin-bottom: 10px;
    }

    .def-price {
        font-size: rem(16);
        margin-right: 3px;
        @include point-md{
            font-size: rem(18);
        }
    }

    .def-price-old {
        font-size: rem(14);
        line-height: 110%;
        color: #757575;
        @include point-md{
            font-size: rem(16);
        }
    }
}
</style>